// One look for every chat on the site (Oct 17, Felipe: "all chat interfaces
// aligned on a similar look and capabilities, still specialised for their
// job"). Each person in a conversation has one colour everywhere: the user
// inbox, the admin inbox, the concierge, the admin's AI-chat monitor and Sage.
//   mine    what you wrote                       terracotta
//   renter  a renter (as an owner or the team sees them)  sky
//   owner   an owner (as a renter or the team sees them)  amber
//   team    the site's team                      tint with a ring
//   ai      the concierge or Sage                grey
//   person  anyone else (a user writing to the team)  grey
// System notes ("Request accepted") are centred small text (ChatNote).

export type ChatRole = "mine" | "renter" | "owner" | "team" | "ai" | "person";

export const CHAT_BUBBLE_CLASS: Record<ChatRole, string> = {
  mine: "bg-primary text-primary-foreground",
  renter: "bg-sky-100 text-sky-950 dark:bg-sky-950 dark:text-sky-50",
  owner: "bg-amber-100 text-amber-950 dark:bg-amber-950 dark:text-amber-50",
  team: "bg-primary/10 text-foreground ring-1 ring-primary/30",
  ai: "bg-muted text-foreground",
  person: "bg-muted text-foreground",
};

/** Where a bubble sits: your own on the right, everyone else on the left unless the surface says otherwise. */
export const defaultSide = (role: ChatRole): "left" | "right" => (role === "mine" ? "right" : "left");
